import React, { FC } from 'react';
import { Text, View } from 'react-native';
import i18n from 'i18n-js';
import { font as initialFont } from '@styles/fonts';
import ColorWrapper from '@styles/colors';
import ReadyPcsQuantity, { ReadyPcsQuantityProps } from './components/ReadyPcsQuantity';
import ReadyPcsBullets from './components/ReadyPcsBullets';
import { ReadyPcsV2Provider } from './context/ReadyPcsV2Context';
import { scale } from '@components/frame';
import { ContainerStyle } from '@interfaces/base';
import { ActiveBulletConfig } from './types';

export interface ReadyPcsV2Props extends ReadyPcsQuantityProps, ContainerStyle {
  activeBulletConfig?: ActiveBulletConfig;
  quantityContainerStyle?: ContainerStyle['containerStyle'];
  minBulletsForWidth?: number;
  readyLabelFont?: keyof typeof initialFont;
}

const ReadyPcsV2: FC<ReadyPcsV2Props> = (props) => {
  const { C, batch, showOnlyTarget, quantityProduced, quantityTarget, font = initialFont, containerStyle, activeBulletConfig, quantityContainerStyle, minBulletsForWidth, readyLabelFont = 'Caption 2' } = props;

  return (
    <ReadyPcsV2Provider batch={batch} showOnlyTarget={showOnlyTarget} quantityProduced={quantityProduced} quantityTarget={quantityTarget}>
      <View style={[{ flex: 1 }, containerStyle]}>
        <Text style={[font[readyLabelFont], { color: C('Label/Light/Tertiary') }]}>{i18n.t('READY')}</Text>
        <View style={[{ marginTop: scale(3), marginBottom: scale(5) }, quantityContainerStyle]}>
          <ReadyPcsQuantity {...props} />
        </View>
        <ReadyPcsBullets activeBulletConfig={activeBulletConfig} minBulletsForWidth={minBulletsForWidth} />
      </View>
    </ReadyPcsV2Provider>
  );
};

export default ColorWrapper(ReadyPcsV2);
